import { StandardContent } from "../../types";

export function isStandardContent(
  content: React.ReactNode | StandardContent
): content is StandardContent {
  return (
    !!content &&
    typeof content === "object" &&
    ("topImage" in content ||
      "title" in content ||
      "subtitle" in content ||
      "body" in content ||
      "primaryButtonProps" in content ||
      "secondaryButtonProps" in content)
  );
}
